module.exports = __webpack_public_path__ + "img/galery22.83414cb7.jpg";